

export default class jsonNodeExportModel {

    id=''
    level=''
    parent=''
    type=''
    label=''
    locuteur=''
    description=''
    source=[]
    destination=[]  // Liste de toutes les destinations (doublons de "sorties")
    requis=[]
    sortie=[] // Les sorties ont leur propre destination


    constructor(TASK) {
        this.id=TASK.id
        this.level=TASK.level+1 // pour que UNIVERS=0
        this.parent=TASK.parent
        this.type=TASK.type
        this.label=TASK.data.label
        this.locuteur=TASK.data.locuteur
        this.description=TASK.data.description
    }

    addSortie(RESULTAT){
        const tmp={
            id:RESULTAT.id,
            type:RESULTAT.type,
            label:RESULTAT.data.label,
            destination:[],
            condition:[],
            consequence:[],
            meta:[]
        }

        this.sortie.push(tmp)
    }

    addCarac(CARAC){

        const tmp={
            clef:CARAC.clef,
            valeur:CARAC.valeur
        }

        //switch
        switch(CARAC.type){
            // PARAMETRE DANS REQUIS
            case "REQ" :{
                this.requis.push(tmp)
                break
            }

            // PARAMETRE DANS CONDITION DE SORTIE
            case "COND" :{
                this.sortie.find(x => x.id === CARAC.lieu).condition.push(tmp)
                break
            }

            // PARAMETRE DANS CONSEQUENCE DE SORTIE
            case "CONS" :{
                this.sortie.find(x => x.id === CARAC.lieu).consequence.push(tmp)
                break
            }

            // PARAMETRE DANS METADONNEES DE SORTIE
            case "META" :{
                this.sortie.find(x => x.id === CARAC.lieu).meta.push(tmp)
                break
            }

            default: {
                break;
            }
        }
    }

    addLinkTo(LINKTO){
        this.destination.push(LINKTO.to)
        const tmp=this.sortie.find(x => x.id === LINKTO.fromExact)
        tmp.destination.push(LINKTO.to)
    }

    addLinkIn(LINKIN){
        this.source.push(LINKIN.from)
    }

}